<template>
  <el-dropdown trigger="click">
    <el-button type="primary" data-qa="content-actions-dropdown">
      {{ $t('Profiles_Button_Actions') }}
      <i class="el-icon-arrow-down el-icon--right" />
    </el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-if="$store.state.app.features.contentImportExport && importEnabled"
        :disabled="!$can('updateProjectItem') || importExportInactive"
        data-qa="import-content-btn"
      >
        <import-content-button
          :show-warning="!isContentEmpty"
          v-model="value"
          :channel="channelTypes[channel]"
          :type="type"
        />
      </el-dropdown-item>
      <el-dropdown-item
        v-if="$store.state.app.features.contentImportExport && exportEnabled"
        :disabled="
          isContentEmpty || !$can('updateProjectItem') || importExportInactive
        "
        data-qa="export-content-btn"
      >
        <export-content-button
          v-model="value"
          :channel="channelTypes[channel]"
          :type="type"
        />
      </el-dropdown-item>
      <el-dropdown-item
        v-if="applyTemplateEnabled"
        data-qa="apply-template-btn"
      >
        <div @click="applyTemplate">
          <i class="el-icon-document" />
          {{ $t('CampaignForm_Button_ApplyTemplate') }}
        </div>
      </el-dropdown-item>
      <el-dropdown-item
        v-if="copyEnabled"
        :disabled="!isCopyActive"
        data-qa="copy-from-btn"
      >
        <div @click="copyFrom">
          <i class="el-icon-copy-document" />
          {{ $t('CampaignForm_Button_CopyFrom') }}
        </div>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import ImportContentButton from '@/modules/campaign-manage/components/ImportContentButton'
import { channelTypes } from '@/modules/campaign-manage/enum/Labels'
import ExportContentButton from '@/modules/campaign-manage/components/ExportContentButton'
import { EventBus } from '@/core/EventBus'

export default {
  name: 'ContentActions',
  components: {
    ExportContentButton,
    ImportContentButton
  },
  props: {
    value: {
      required: true
    },
    channel: {
      required: true
    },
    importEnabled: {
      default: false,
      type: Boolean
    },
    exportEnabled: {
      default: false,
      type: Boolean
    },
    importExportInactive: {
      default: false,
      type: Boolean
    },
    applyTemplateEnabled: {
      default: false,
      type: Boolean
    },
    copyEnabled: {
      default: false,
      type: Boolean
    },
    model: {
      required: true
    },
    isContentEmpty: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      channelTypes
    }
  },
  computed: {
    type() {
      if (['inapp', 'onsite'].includes(this.$route.query.channel)) {
        if (this.value.hasOwnProperty('inapp_type')) {
          return this.value.inapp_type
        }
        if (this.value.hasOwnProperty('onsite_type')) {
          return this.value.onsite_type
        }
      }
      return 'default'
    },
    isCopyActive() {
      if (this.model.ab === 1 || this.model.languages_multi === 1) {
        return true
      }
      if (
        this.model.web_push === 1 &&
        ['inbox'].includes(this.$route.query.channel)
      ) {
        return true
      }
      return (
        this.model.ios_push === 1 &&
        this.model.android_push === 1 &&
        ['ios_push', 'android_push'].includes(this.$route.query.channel)
      )
    }
  },
  methods: {
    copyFrom() {
      EventBus.$emit('copyFromDialog', channelTypes[this.$route.query.channel])
    },
    applyTemplate() {
      EventBus.$emit(
        'applyMessageTemplateDialog',
        channelTypes[this.$route.query.channel]
      )
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/ContentActions.vue